import { useState } from 'react'

export const CartActions = () => {
  const [cart, setCart] = useState<any>({
    produtos: [],
    planos: [],
    servicos: []
  })

  const setPlanSelected = (plan?: any) => {
    setCart({
      ...cart,
      planos: [plan]
    })
  }

  const setServiceSelected = (service?: any) => {
    setCart({
      ...cart,
      servicos: [service]
    })
  }

  const setProductsSelected = (product?: any) => {
    if (!product) return

    const productFind = cart.produtos.find((item: any) => item.id == product.id)

    if (!productFind) {
      setCart({
        ...cart,
        produtos: [...cart.produtos, product]
      })
      return
    }

    const productsUpdated = cart.produtos.map((item: any) => {
      if (item.id == product.id) {
        item.quantidade += product.quantidade
      }

      return item
    })

    setCart({
      ...cart,
      produtos: productsUpdated
    })
  }

  const updateCart = (data: any) => {
    setCart(data)
  }

  const calculateItemsInCart = () => {
    const totalItemsProducts = cart.produtos.reduce((total: any, item: any) => total + item.quantidade, 0)
    return cart.planos.length + totalItemsProducts + cart.servicos.length
  }

  const calculateTotal = (cart: any) => {
    const productsTotal = cart.produtos.reduce((total: any, item: any) => total + item.quantidade * item.valor, 0)
    const servicesTotal = cart.servicos.reduce((total: any, item: any) => total + item.valor, 0)
    const plansTotal = cart.planos.reduce((total: any, item: any) => total + item.valor, 0)

    return productsTotal + servicesTotal + plansTotal || 0
  }

  const clearCart = () => {
    setCart({
      produtos: [],
      planos: [],
      servicos: []
    })
  }

  return {
    cart,
    setPlanSelected,
    setServiceSelected,
    setProductsSelected,
    updateCart,
    calculateItemsInCart,
    calculateTotal,
    clearCart
  }
}
